import { useTranslation } from 'react-i18next';
import { LiliTextArea } from '@lili/lili-frontend-common';
import { ControllerWrapper } from '@Hooks/index';
import { EddEmbeddedFields } from '@Pages/happyFlowPages/eddQuestions/pages/embedded/fields.types';

export const BeneficiarySelectionForm = () => {
  const { t } = useTranslation('eddQuestions');

  return (
    <div className='flex flex-col gap-[8px]'>
      <ControllerWrapper name={EddEmbeddedFields.EDD_BENEFICIARY_SELECTION}>
        {({ onChange, value, error, onBlur }) => (
          <LiliTextArea
            value={value}
            onValueChange={onChange}
            errorMsg={error?.message || ''}
            externalErrorMessage={error?.message || ''}
            maxLength={300}
            minHeight='min-h-[180px]'
            placeholder={t('organic.beneficiarySelection.placeholder')}
            onBlur={onBlur}
          />
        )}
      </ControllerWrapper>
    </div>
  );
};
